import { Link } from "react-router";
import { CheckCircle2, CircleAlert, Mail } from "lucide-react";
import { reais, type ResultadoDoEnvio } from "@/lib/dinheiro";
import { cn } from "@/lib/cn";

type Email = { exibicao: string; origem: "COBRANCA" | "CADASTRO" | "CONTA" } | null;

const ORIGEM: Record<NonNullable<Email>["origem"], string> = {
  COBRANCA: "e-mail da cobrança",
  CADASTRO: "e-mail do cadastro",
  CONTA: "e-mail da conta",
};

/** Uma linha do "Fechar e enviar": marcar, quem, quanto e para onde vai. */
export function LinhaDoEnvio(props: {
  marcado: boolean;
  onMarcar: (v: boolean) => void;
  nome: string;
  detalhe: string;
  valorCents: number;
  email: Email;
  partnerId: string | null;
  aviso?: string | null;
}) {
  const { marcado, onMarcar, nome, detalhe, valorCents, email, partnerId, aviso } = props;
  return (
    <li className="flex items-start gap-3 px-3 py-2.5">
      <input type="checkbox" checked={marcado} onChange={(e) => onMarcar(e.target.checked)} className="mt-1 h-4 w-4 shrink-0 accent-brand-600" aria-label={`Incluir ${nome}`} />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-semibold text-zinc-900 dark:text-foreground">{nome}</p>
        <p className="truncate text-[11px] text-zinc-500 dark:text-muted-foreground">{detalhe}</p>
        {email ? (
          <p className="mt-0.5 flex items-center gap-1 truncate text-[11px] text-zinc-600 dark:text-muted-foreground">
            <Mail className="h-3 w-3 shrink-0" />
            {email.exibicao} <span className="text-zinc-400">· {ORIGEM[email.origem]}</span>
          </p>
        ) : (
          <p className="mt-0.5 text-[11px] font-semibold text-amber-600">
            Sem e-mail: emite, mas não envia.{" "}
            {partnerId && (
              <Link to={`/lab/cadastros/${partnerId}?aba=dados`} className="underline">
                Cadastrar
              </Link>
            )}
          </p>
        )}
        {aviso && <p className="mt-0.5 text-[11px] font-semibold text-amber-600">{aviso}</p>}
      </div>
      <span className="shrink-0 text-sm font-semibold tabular-nums text-zinc-900 dark:text-foreground">{reais(valorCents)}</span>
    </li>
  );
}

/** O resultado do envio, um extrato por linha. */
export function ResultadoDoEnvioLinha({ r }: { r: ResultadoDoEnvio }) {
  const ok = r.enviado;
  return (
    <li className="flex items-start gap-2 px-3 py-2 text-sm">
      {ok ? <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /> : <CircleAlert className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />}
      <div className="min-w-0 flex-1">
        <p className="truncate font-medium text-zinc-900 dark:text-foreground">
          {r.numero != null && <span className="text-zinc-500">Nº {r.numero} · </span>}
          {r.nome}
        </p>
        <p className={cn("text-[11px]", ok ? "text-zinc-500 dark:text-muted-foreground" : "text-amber-600")}>
          {[r.emitido ? "Emitido" : null, ok ? `enviado para ${r.para}` : r.erro].filter(Boolean).join(" · ")}
        </p>
      </div>
    </li>
  );
}
